import React, { useState, useEffect, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SocialProof.css';

const FUNNEL_STATUSES = [
  {
    key: 'viewing',
    label: 'Viendo ahora',
    color: 'green',
    message: service => `está revisando ${service}`
  },
  {
    key: 'selected',
    label: 'Seleccionó plan',
    color: 'yellow',
    message: service => `seleccionó ${service}`
  },
  {
    key: 'whatsapp',
    label: 'Abrió WhatsApp',
    color: 'blue',
    message: () => `abrió WhatsApp para consultar`
  },
  {
    key: 'contacted',
    label: 'Solicitó información',
    color: 'dark',
    message: () => `solicitó más información`
  }
];

const SocialProof = () => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const notifications = useMemo(() => [
    {
      id: 1,
      name: "María González",
      location: "San Isidro, Lima",
      service: "Plan Vida Plena 365",
      modalidad: "Presencial"
    },
    {
      id: 2,
      name: "Carlos Ramírez",
      location: "Arequipa",
      service: "Plan Mes de Cambios",
      modalidad: "Virtual"
    },
    {
      id: 3,
      name: "Empresa TechSolutions",
      location: "Miraflores, Lima",
      service: "Nutrición Empresarial",
      modalidad: "Presencial"
    },
    {
      id: 4,
      name: "Ana Medina",
      location: "Surco, Lima",
      service: "Plan Mes de Cambios",
      modalidad: "Virtual"
    },
    {
      id: 5,
      name: "Jorge Castillo",
      location: "Cusco",
      service: "Plan Vida Plena 365",
      modalidad: "Virtual"
    }
  ], []);

  useEffect(() => {
    const showNotification = () => {
      const randomUser =
        notifications[Math.floor(Math.random() * notifications.length)];

      const randomStatus =
        FUNNEL_STATUSES[Math.floor(Math.random() * FUNNEL_STATUSES.length)];

      setCurrentNotification({
        ...randomUser,
        status: randomStatus
      });

      setIsVisible(true);

      setTimeout(() => {
        setIsVisible(false);
      }, 7500);
    };

    const initial = setTimeout(showNotification, 3000);
    const interval = setInterval(showNotification, 14000);

    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, [notifications]);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <AnimatePresence mode="wait">
      {isVisible && currentNotification && (
        <motion.div
          key={`${currentNotification.id}-${currentNotification.status.key}`}
          initial={{ opacity: 0, x: -40, y: 10 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -40, y: 10 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="social-proof"
        >
          <button
            className="sp-close-btn"
            onClick={handleClose}
            aria-label="Cerrar notificación"
          >
            ×
          </button>

          <div className="sp-header">
            <div className="sp-live-indicator">
              <span className="sp-live-dot"></span>
              <span className="sp-live-text">En vivo</span>
            </div>

            <span
              className={`sp-status-badge sp-status-${currentNotification.status.color}`}
            >
              {currentNotification.status.label}
            </span>
          </div>

          <div className="sp-body">
            <p className="sp-name">{currentNotification.name}</p>

            <p className="sp-service">
              {currentNotification.status.message(
                currentNotification.service
              )}
            </p>

            <div className="sp-meta">
              <span className="sp-meta-item">
                📍 {currentNotification.location}
              </span>
              <span className="sp-meta-separator">•</span>
              <span className="sp-meta-item">
                {currentNotification.modalidad}
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SocialProof;